import { createContext } from "react";

export const CurrentUserContext = createContext();

export const currentUser = {
  name: "Жак-Ив Кусто",
  about: "Исследователь океана",
  avatar: "",
};
